import React from 'react';

/** Menopause Decision Desk™ wordmark with the gold leaf mark. */
export function Wordmark({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const text = tone === 'dark' ? 'text-navy' : 'text-cream';
  return <div className="flex items-center justify-center gap-2.5" data-id="element-367" data-mp="2k1mwtbg0hqb">
      <svg viewBox="0 0 24 32" className="h-7 w-auto shrink-0" aria-hidden="true" data-id="element-368" data-mp="6kkf4oh8zpt1">
        <path d="M12 32V13" stroke="#B4894A" strokeWidth="1.6" strokeLinecap="round" fill="none" data-id="element-369" data-mp="6metfjy0kjo5" />
        <path d="M12 14C12 6 6 2 1 1c0 8 5 12 11 13Z" fill="#B4894A" data-id="element-370" data-mp="3azld1jgthk15" />
        <path d="M12 18C12 11 17 7 23 6c0 8-5 12-11 12Z" fill="#D6B071" data-id="element-371" data-mp="3ezm1zy1jldmg" />
      </svg>
      <span className={`font-serif text-[13px] font-bold uppercase leading-[1.15] tracking-[0.16em] ${text}`} data-id="element-372" data-mp="3jzqivp6d4ad7">
        Menopause
        <br data-id="element-373" data-mp="u9n0a6b3c0sa" />
        Decision Desk™
      </span>
    </div>;
}